<div class="payment-preview">

  <div class="payment-preview__loading" *ngIf="loading">
    <i class="fas fa-spinner fa-spin"></i>
    Consultando el detalle del pago...
  </div>

  <div class="payment-preview__alert payment-preview__alert--error" *ngIf="!loading && error">
    <i class="fas fa-exclamation-circle"></i>
    <span>{{error}}</span>
  </div>

  <ng-container *ngIf="!loading && !error">

    <div class="payment-preview__alert payment-preview__alert--empty" *ngIf="!hasPreview">
      <i class="fas fa-info-circle"></i>
      <span>No hay servicios para previsualizar.</span>
    </div>

    <ng-container *ngIf="hasPreview">

      <div class="payment-preview__title">Detalle del pago por beneficiario</div>
      <div class="payment-preview__subtitle">
        <ng-container *ngIf="!isNotConsolidated">
          Los servicios de un mismo beneficiario se pagan en una sola transferencia.
        </ng-container>
        <ng-container *ngIf="isNotConsolidated">
          Tu compañía no consolida pagos: cada servicio genera su propia transferencia.
        </ng-container>
        Los servicios que no entran al pago se muestran igual, junto a su beneficiario.
      </div>

      <div class="payment-preview__alert payment-preview__alert--warning" *ngIf="hasEstimatedGroups">
        <i class="fas fa-exclamation-triangle"></i>
        <span>
          Algunos totales son aproximados: hay servicios en saldo negativo que se cruzan
          al momento de pagar, así que el valor transferido puede ser menor.
        </span>
      </div>

      <div class="payment-preview__alert payment-preview__alert--excluded" *ngIf="totalExcluded">
        <i class="fas fa-ban"></i>
        <span>
          <strong>
            {{totalExcluded}} de {{totalServices}}
            {{totalExcluded === 1 ? 'servicio no se pagará' : 'servicios no se pagarán'}}
          </strong>
          y no {{totalExcluded === 1 ? 'suma' : 'suman'}} al total. Cada uno indica su motivo en la tabla.
        </span>
      </div>

      <div class="payment-preview__alert payment-preview__alert--info" *ngIf="!hasTransfers">
        <i class="fas fa-info-circle"></i>
        <span>Ninguno de los servicios seleccionados genera transferencia. Revisa el detalle de abajo.</span>
      </div>

      <div class="payment-preview__table-wrapper">
        <table class="payment-preview__table">
          <thead>
            <tr>
              <th class="payment-preview__col-toggle"></th>
              <th>Consecutivo</th>
              <th>Placa</th>
              <th>Conductor</th>
              <th>Estado</th>
              <th class="text-right">Valor</th>
            </tr>
          </thead>
          <tbody>

            <ng-container *ngFor="let groupView of groupViews">
              <tr class="payment-preview__group-row" [class.payment-preview__row--estimated]="groupView.estimated"
                [class.payment-preview__row--muted]="!groupView.transfers" (click)="toggleGroup(groupView)">
                <td class="payment-preview__col-toggle">
                  <i class="fas" [ngClass]="groupView.expanded ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                </td>
                <td colspan="4">
                  <div class="payment-preview__group-name">{{ beneficiaryName(groupView.bankAccount) }}</div>
                  <div class="payment-preview__muted">
                    <ng-container *ngIf="bankName(groupView.bankAccount)">
                      {{ bankName(groupView.bankAccount) }} &middot;
                    </ng-container>
                    {{ groupView.bankAccount?.accountNumber || 'Sin número de cuenta' }}
                    <ng-container *ngIf="groupView.bankAccount?.accountType">
                      &middot; {{ groupView.bankAccount.accountType }}
                    </ng-container>
                    <ng-container *ngIf="groupView.bankAccount?.document">
                      &middot; CC/NIT {{ groupView.bankAccount.document }}
                    </ng-container>
                  </div>
                </td>
                <td class="text-right">
                  <div class="payment-preview__amount" *ngIf="groupView.transfers">
                    <span *ngIf="groupView.estimated" class="payment-preview__estimated"
                      matTooltip="El valor puede bajar al pagar: se cruzará un saldo negativo del mismo conductor.">
                      &asymp;
                    </span>
                    {{ groupView.totalAmount | currency:'COP':'code' }}
                  </div>
                  <div class="payment-preview__no-transfer" *ngIf="!groupView.transfers">
                    No genera transferencia
                  </div>
                  <div class="payment-preview__muted" *ngIf="!groupView.excludedCount">
                    {{groupView.services.length}}
                    {{groupView.services.length === 1 ? 'servicio' : 'servicios'}}
                  </div>
                  <div class="payment-preview__excluded-count" *ngIf="groupView.excludedCount">
                    {{groupView.excludedCount}} de {{groupView.services.length}}
                    {{groupView.excludedCount === 1 ? 'no se paga' : 'no se pagan'}}
                  </div>
                </td>
              </tr>

              <ng-container *ngIf="groupView.expanded">
                <tr class="payment-preview__service-row" *ngFor="let service of groupView.services"
                  [class.payment-preview__row--excluded]="!isPayable(service)"
                  [class.payment-preview__row--excluded-error]="!isPayable(service) && severity(service) === 'error'">
                  <td></td>
                  <td class="text-nowrap">{{service.consecutive || '-'}}</td>
                  <td class="text-nowrap">{{service.licensePlate || '-'}}</td>
                  <td>{{service.driverName || '-'}}</td>
                  <td>
                    <span class="payment-preview__badge payment-preview__badge--success" *ngIf="isPayable(service)">
                      <i class="fas fa-check"></i> Se paga
                    </span>
                    <ng-container *ngIf="!isPayable(service)">
                      <span class="payment-preview__badge" [ngClass]="'payment-preview__badge--' + severity(service)">
                        <i class="fas fa-ban"></i> No se paga
                      </span>
                      <div class="payment-preview__reason">{{ statusMessage(service) }}</div>
                    </ng-container>
                  </td>
                  <td class="text-right payment-preview__amount">
                    <ng-container *ngIf="isPayable(service); else excludedAmount">
                      {{ service.amount | currency:'COP':'code' }}
                    </ng-container>
                    <ng-template #excludedAmount>
                      <span class="payment-preview__no-transfer">No suma</span>
                    </ng-template>
                  </td>
                </tr>

                <tr class="payment-preview__group-note" *ngIf="groupView.estimated">
                  <td></td>
                  <td colspan="5">
                    <div class="payment-preview__cross">
                      <i class="fas fa-exclamation-triangle"></i>
                      <span>
                        <ng-container *ngIf="groupView.negativeCargos.length">
                          Este total es aproximado porque al pagar se cruzará el saldo negativo de
                          <span class="payment-preview__chip payment-preview__chip--negative"
                            *ngFor="let negative of groupView.negativeCargos">
                            {{negative.consecutive || negative.licensePlate || '-'}}
                          </span>
                          del mismo conductor.
                        </ng-container>
                        <ng-container *ngIf="!groupView.negativeCargos.length">
                          Este total es aproximado: al pagar se cruzará un saldo negativo del mismo conductor
                          y el valor transferido puede ser menor.
                        </ng-container>
                      </span>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </ng-container>

            <!-- Sin beneficiario al cual asociarlos -->
            <ng-container *ngIf="unresolvedServices.length">
              <tr class="payment-preview__group-row payment-preview__row--muted" (click)="toggleUnresolved()">
                <td class="payment-preview__col-toggle">
                  <i class="fas" [ngClass]="unresolvedExpanded ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                </td>
                <td colspan="4">
                  <div class="payment-preview__group-name">Sin cuenta bancaria resuelta</div>
                  <div class="payment-preview__muted">
                    No se pudo determinar a quién pagarles. Requieren corregir los datos del servicio.
                  </div>
                </td>
                <td class="text-right">
                  <div class="payment-preview__no-transfer">No genera transferencia</div>
                  <div class="payment-preview__muted">
                    {{unresolvedServices.length}}
                    {{unresolvedServices.length === 1 ? 'servicio' : 'servicios'}}
                  </div>
                </td>
              </tr>

              <tr class="payment-preview__service-row payment-preview__row--excluded payment-preview__row--excluded-error"
                *ngFor="let service of unresolvedServices" [hidden]="!unresolvedExpanded">
                <td></td>
                <td class="text-nowrap">{{service.consecutive || '-'}}</td>
                <td class="text-nowrap">{{service.licensePlate || '-'}}</td>
                <td>{{service.driverName || '-'}}</td>
                <td>
                  <span class="payment-preview__badge" [ngClass]="'payment-preview__badge--' + severity(service)">
                    <i class="fas fa-ban"></i> No se paga
                  </span>
                  <div class="payment-preview__reason">{{ statusMessage(service) }}</div>
                </td>
                <td class="text-right"><span class="payment-preview__no-transfer">No suma</span></td>
              </tr>
            </ng-container>

          </tbody>
          <tfoot>
            <tr>
              <td colspan="5" class="text-right">Total a pagar</td>
              <td class="text-right payment-preview__amount payment-preview__total">
                {{ preview.totalAmount | currency:'COP':'code' }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

    </ng-container>
  </ng-container>
</div>
